import React, { FC } from "react";
import { Modal, Tabs, notification } from "antd";
import { useMutation } from "@apollo/react-hooks";
import { AddUserFromEmailPanel } from "./AddUserFromEmailPanel";
import { AddUserPanel } from "./AddUserPanel";
import { OrgGql } from "../../../graphql/organization";
import { ApolloError } from "apollo-boost";

const { TabPane } = Tabs;

export const AddUserDlg: FC<any> = ({ orgId, grades, onClose }) => {
  const [addOrgMember, { loading: saving }] = useMutation(OrgGql.addOrgMember);

  const onAdded = (ok) => {
    onClose(ok);
  };

  const onAdd = ({ id: userId }) => {
    addOrgMember({ variables: { orgId, userId } })
      .then(() => {
        notification.success({ message: `Add user successed!` });
        onClose(true);
      })
      .catch((err: ApolloError) => {});
  };

  return (
    <Modal
      className="user-details"
      title="Add User"
      visible={true}
      confirmLoading={saving}
      maskClosable={false}
      width={600}
      onCancel={() => onClose(true)}
      footer={null}
    >
      <Tabs defaultActiveKey="12">
        <TabPane tab="Find by Email" key="2">
          <AddUserFromEmailPanel selectText="Add as Org User" onSelect={onAdd} />
        </TabPane>
        <TabPane tab="Create New" key="3">
          <AddUserPanel orgId={orgId} onClose={onAdded} />
        </TabPane>
      </Tabs>
    </Modal>
  );
};
